/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
} from './Bed';

/**
 * 
 * @export
 * @interface FindOneBed200Response
 */
export interface FindOneBed200Response {
    /**
     * 
     * @type {Bed}
     * @memberof FindOneBed200Response
     */
    data?: Bed;
}

/**
 * Check if a given object implements the FindOneBed200Response interface.
 */
export function instanceOfFindOneBed200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOneBed200ResponseFromJSON(json: any): FindOneBed200Response {
    return FindOneBed200ResponseFromJSONTyped(json, false);
}

export function FindOneBed200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneBed200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BedFromJSON(json['data']),
    };
}

export function FindOneBed200ResponseToJSON(value?: FindOneBed200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BedToJSON(value.data),
    };
}

